import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBrg3MjO-Csyu2NlOGDNb1viY9-2DhKy58",
  authDomain: "alfa-pwa-5e7c4.firebaseapp.com",
  projectId: "alfa-pwa-5e7c4",
  storageBucket: "alfa-pwa-5e7c4.firebasestorage.app",
  messagingSenderId: "272247323433",
  appId: "1:272247323433:web:91d754740fd0398d401538",
  measurementId: "G-RF4CC32XQF"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);


export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  //console.log(permission)

  if (permission === 'granted') {
    const token = await getToken(messaging, { 
      vapidKey: 
      "BCLXOpfa-6BcKhPJHy3LbWUVez8tSm6VOT0BRjcClWxdAR2ANPTYrWViYM4e25YocjBGokKKh70DcITML5-5nr4"
    })
    //console.log(token)
  }
}

export { messaging }
